// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"42aaa5ba","498":"518444e1"}[chunkId] + ".chunk.js";
};